import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n  from './lang/i18n.js'; // 国际化功能
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css'; // Element 额外提供了一系列类名，用于在某些条件下隐藏元素。这些类名可以添加在任何 DOM 元素或自定义组件上。
import '@/assets/theme/theme.css' // 颜色主题CSS样式文件
import '@/assets/css/style.css' // 引入全局组件样式文件-->用于组件主题色切换


Vue.use(ElementUI);

Vue.config.productionTip = false

// 创建事件总线实例
const eventBus = new Vue();
// 将事件总线实例挂载到Vue原型上，方便在组件中访问
Vue.prototype.$eventBus = eventBus;


new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
